import React from 'react';
import eventData from '../../assets/Schedule/schedule.json';
import { Section, SubTitle, ScheduleTitle, ScheduleContainer, ScheduleColumn, RowItem, Row, BackgroundImage} from './styles';
import background from '../../assets/Schedule/clouds.png';


const Schedule: React.FC = () => {
  return (
    <Section id="schedule">
      <ScheduleTitle>SCHEDULE</ScheduleTitle> 
      <BackgroundImage src={background} alt="clouds" />
      <ScheduleContainer>
        <ScheduleColumn>
          <SubTitle>Saturday, October 12th</SubTitle>
          <div>
            {eventData.SATURDAY.map((event: any, index: number) => (
              <Row key={index}>
                <RowItem>{event.time}</RowItem>
                <RowItem>{event.description}</RowItem>
              </Row>
            ))}
          </div>
        </ScheduleColumn>
        <ScheduleColumn>
          <SubTitle>Sunday, October 13th</SubTitle>
          <div>
            {eventData.SUNDAY.map((event: any, index: number) => (
              <Row key={index}>
              <RowItem>{event.time}</RowItem>
              <RowItem>{event.description}</RowItem>
            </Row>
            ))}
          </div>
        </ScheduleColumn>
      </ScheduleContainer>
    </Section>
  );
}

export default Schedule;
